import React from "react";
import moment from "moment";
import { transparentize } from "polished";
import { withStyles } from "@material-ui/core";
import { omit } from "@bonliva-crm/common";
import NotifIcon from "@material-ui/icons/NotificationImportantRounded";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import locale from "@bonliva-crm/locale";
import { TicketEventFragment as EventData } from "@graphql";
import { store } from "@store";
import { Classes, ThemeType } from "@theme";
import UserAvatar from "@containers/UserAvatar";
import { SubParagraph } from "@components/typography/SubParagraph";
import { Paragraph } from "@components/typography/Paragraph";
import Highlighter from "@components/Highlighter";
import { Event } from "../../Event/Event";

type Props = {
  classes: Classes<typeof styles>;
  item: EventData;
  search?: string | RegExp;
};

class ReminderEvent extends React.Component<Props> {
  renderTodoParams = () => {
    const { classes, item } = this.props;
    const { TodoItem } = item;

    if (!TodoItem) {
      return null;
    }

    let assignedTo = null;

    if (TodoItem.AssignedTo.PersonId !== store().user.id) {
      assignedTo = (
        <div data-test="ReminderEventAssignedTo" className={classes.subtitleEl}>
          <div className={classes.subTitleLabel}>
            <UserAvatar
              userName={TodoItem.AssignedTo.Name}
              size="micro"
              style={{ marginRight: 4 }}
            />
            {locale["Assigned to"]}:
          </div>
          <div className={classes.subTitleValue}>
            <strong>{TodoItem.AssignedTo.Name}</strong>
          </div>
        </div>
      );
    }

    const completed = (
      <div data-test="ReminderEventCompleted" className={classes.subtitleEl}>
        <div className={classes.subTitleLabel}>{locale.Completed}:</div>
        <div className={classes.subTitleValue}>
          {TodoItem.Completed ? locale.Yes : locale.No}
        </div>
      </div>
    );

    const due = TodoItem.Due ? (
      <div data-test="ReminderEventDue" className={classes.subtitleEl}>
        <div className={classes.subTitleLabel}>
          <CalendarTodayIcon fontSize="inherit" />
          {locale.DueDate}:
        </div>
        <div className={classes.subTitleValue}>{moment(TodoItem.Due).calendar()}</div>
      </div>
    ) : null;

    return (
      <SubParagraph style={{ display: "flex", flex: 1 }}>
        {assignedTo} {due} {completed}
      </SubParagraph>
    );
  };

  render() {
    const { item, search } = this.props;

    return (
      <Event
        key={this.props.item._id}
        icon={<NotifIcon />}
        {...omit(this.props, "classes")}
      >
        {this.renderTodoParams()}

        <Paragraph>
          <Highlighter nl2br search={search}>
            {item.Description}
          </Highlighter>
        </Paragraph>
      </Event>
    );
  }
}

const styles = (theme: ThemeType) => ({
  todoParams: {
    marginBottom: theme.spacing()
  },

  subtitleEl: {
    alignItems: "center",
    borderRadius: 4,
    display: "flex",
    // flex: 1,
    flexWrap: "wrap",
    marginLeft: 4,
    marginTop: -2,
    marginBottom: -2,
    padding: 2,
    backgroundColor: transparentize(0.88, theme.palette.secondary.light),
    border: `1px solid ${transparentize(0.83, theme.palette.secondary.light)}`,

    "&:first-child": {
      marginLeft: 0
    },

    "& > div": {
      marginRight: 4
    },

    "& svg": {
      marginRight: 4
    }
  },

  subTitleLabel: {
    alignItems: "center",
    display: "flex"
  },

  subTitleValue: {
    flex: 1,
    whiteSpace: "nowrap"
  }
});

export default withStyles(styles as any)(ReminderEvent);
